import React from 'react'
import PropTypes from 'prop-types'
import getBannerContent from './hooks'
import bannerImg from './banner-img.svg'

import {
  FluidBanner,
  FluidContentContainer,
  SmallImage,
  SmallCopy,
  Title,
  SmallContent,
} from './styles'

// Note: designed to keep compatibility with Sundae
const SmallBanner = ({ doFindFriend }) => {
  const contentKey = doFindFriend ? 'primary' : 'secondary'
  const bannerContent = getBannerContent(doFindFriend, contentKey)

  if (!bannerContent) {
    return null
  }

  return (
    <FluidBanner>
      <FluidContentContainer>
        <SmallImage src={bannerImg} alt="Sharing is caring" />
        <SmallCopy>
          <Title>{bannerContent ? bannerContent.title : ''}</Title>
          <SmallContent>
            {bannerContent ? bannerContent.content : ''}
          </SmallContent>
        </SmallCopy>
      </FluidContentContainer>
    </FluidBanner>
  )
}

SmallBanner.propTypes = {
  doFindFriend: PropTypes.bool,
}

export default SmallBanner
